<template>
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/Arbitrage">실시간시세</router-link> |
    <router-link to="/Community">커뮤니티</router-link> |
    <router-link to="/News">코인뉴스</router-link> |
    <router-link :to="{name: 'BBSList'}">자유게시판</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
